<template>
    <div id="search_filter" data-simplebar >
        <div>
            <property-type-filter @filter="filterResults" />

            <ad-type-filter @filter="filterResults" />

            <district-filter @filter="filterResults" />

            <gender-filter @filter="filterResults" />

            <rent-price-filter @filter="filterResults" />

            <amenity-filter @filter="filterResults" />

            <rule-filter @filter="filterResults" />
        </div>
        <!-- <breadcrumbs @filter="filterResults" /> -->
    </div>
</template>

<script>
import DistrictFilter from './filters/district.vue';
import RentPriceFilter from './filters/rent_price.vue';
import Breadcrumbs from './filters/breadcrumbs.vue';
import PropertyTypeFilter from './filters/property_type.vue';
import AdTypeFilter from './filters/ad_type.vue';
import GenderFilter from './filters/gender.vue';
import AmenityFilter from './filters/amenity.vue';
import RuleFilter from './filters/rule.vue';
export default {
    components: {
        DistrictFilter,
        RentPriceFilter,
        Breadcrumbs,
        PropertyTypeFilter,
        AdTypeFilter,
        GenderFilter,
        AmenityFilter,
        RuleFilter
    },
    data() {
        return {}
    },
    methods: {
        filterResults() {
            this.$emit('filterResults');
        },
    }
}
</script>
